import { action, extendObservable, makeObservable, runInAction, set, toJS } from 'mobx';

class Observable<T extends object> {
    private readonly entry: T;

    constructor(entry: T) {
        this.entry = { ...entry };
        makeObservable(this, {
            reset: action,
            set: action,
            update: action,
            handleChange: action,
        });
        extendObservable(this, entry);
    }

    reset = (key?: keyof T) => {
        if (key) {
            this.set(key, this.entry[key]);
        } else {
            this.update(this.entry);
        }
    };

    update = (entry: Partial<T>) => {
        runInAction(() => {
            for (const key in entry) {
                set(this, key, entry[key]);
            }
        });
    };

    set = <Key extends keyof T>(key: Key, value: T[Key]): T[Key] => {
        if ((this as any)[key] !== value) {
            runInAction(() => {
                set(this, key, value);
            });
        }
        return value;
    };

    toggle = <Key extends keyof T>(key: Key) => {
        runInAction(() => {
            set(this, key, !(this as any)[key]);
        });
    };

    handleChange = <R>(data: { name: string; value: R }) => {
        runInAction(() => {
            set(this, data.name, data.value);
        });
    };

    // handler = <Key extends keyof T>(key: Key) => {
    //     return {
    //         name: key,
    //         value: (this as unknown as T)[key] || null as T[Key] | null,
    //         onChange: this.handleChange,
    //     }
    // }

    toObject = (): T => {
        const result: any = {};
        for (const key in this.entry) {
            result[key] = (this as any as T)[key];
        }
        return result as T;
    };

    toRaw = () => {
        return toJS(this);
    };
}

export const observable = <T extends object>(entry: T) => {
    return new Observable(entry) as Observable<T> & T;
};
